<!--
 * @Descripttion: 用户协议、隐私政策
 * @FilePath: /mall-wap-vue/src/views/login/components/Agreement/index.vue
 * @Author: 张兴业
 * @Date: 2020-10-09 20:09:12
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-12-25 17:09:30
-->
<template>
  <div class="agreement">
    <van-field name="agree" v-model="agree" class="agreement_filed">
      <template #input>
        <div class="login_argument font_weight400 font12 text_center">
          <div class="clearfix">
            <img
              v-if="agree === '1'"
              src="@/assets/login/select@2x.png"
              alt=""
              class="select_img left"
              @click="unselectedAgreement"
            />
            <img
              v-if="agree === '0'"
              src="@/assets/login/unselect@2x.png"
              alt=""
              class="select_img left"
              @click="selectedAgreement"
            />
            <div class="left">
              <span>同意 </span>
              <span class="argu_line colo0" @click.stop="goLogin1"
                >用户协议
              </span>
              <span> 和 </span>
              <span class="argu_line colo0" @click.stop="goLogin2"
                >隐私政策</span
              >
            </div>
          </div>
        </div>
      </template>
    </van-field>
  </div>
</template>

<script>
export default {
  props: ["value"],
  data() {
    return {
      agree: this.value
    };
  },
  methods: {
    selectedAgreement() {
      this.agree = "1";
      this.$emit("input", "1");
    },
    unselectedAgreement() {
      this.agree = "0";
      this.$emit("input", "0");
    },
    goLogin1() {
      if (this.$appSource === 3) {
        this.$router.push("/agreement?key=1&name=用户协议");
      } else {
        this.$router.push("/agreement/login1");
      }
    },
    goLogin2() {
      if (this.$appSource === 3) {
        this.$router.push("/agreement?key=2&name=隐私政策");
      } else {
        this.$router.push("/agreement/login2");
      }
    }
  }
};
</script>

<style lang="less" scoped>
.agreement {
  margin-top: 12px;
}
.agreement_filed {
  padding: 0;
}
.login_argument {
  margin: 0 auto 0;
  color: rgba(0, 0, 0, 0.5);
  line-height: 20px;
  .select_img {
    width: 18px;
    height: 18px;
    margin-right: 8px;
  }
  .argu_line {
    display: inline-block;
    text-decoration: underline;
  }
}
</style>
